import type { FC } from 'react';
import { lazy } from 'react';
import { useParams } from 'react-router';
import { useMemoOne } from 'use-memo-one';
import type { ContractsParams } from 'src/apis/contract-management/types';
import type { ContractManagementRequest } from 'src/apis/contract-management/use-contract-management';
import { useContracts } from 'src/apis/contract-management/use-contracts';

const Page = lazy(() => import('./page'));

type ShipperContractsProps = {
  contractManagement: ContractManagementRequest;
  shipperName: string;
};

export const ShipperContracts: FC<ShipperContractsProps> = ({
  contractManagement,
  shipperName,
}) => {
  const { shipperUuid } = useParams<{ shipperUuid: string }>();
  const params = useMemoOne<ContractsParams>(
    () => ({ shipperId: [shipperUuid] }),
    [shipperUuid]
  );
  const contracts = useContracts({ contractManagement, params });
  return <Page contracts={contracts} shipperName={shipperName} />;
};
